import { Link } from 'react-router-dom';
import { SEOHead } from '../components/seo/SEOHead';
import { Button } from '../components/ui/Button';

export default function NotFound() {
  return (
    <>
      <SEOHead title="Page Not Found — Bharat Consultancy" description="" />
      <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
        <h1 className="font-display text-4xl font-bold text-ink">404</h1>
        <p className="mt-2 text-ink/60">This page doesn't exist or has moved.</p>
        <Link to="/" className="mt-6">
          <Button>Back to Home</Button>
        </Link>
      </div>
    </>
  );
}
